/*
 * @Author: Teemo Ding
 * @Date: 2022-02-17 15:44:24
 * @LastEditTime: 2022-06-06 10:35:26
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Communication/Detail/CommunicationGateway/Components/Zhima.tsx
 */
import { Input, Label } from '@/src/components/Antd';
import Row from '@/src/components/Layouts/Row/Row';
import { Form } from 'antd';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { InputWithValue } from '../../../Components/FormComponents';

const Zhima = ({ editable, disabled }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Fragment>
      <Row
        elements={[
          {
            child: (
              <Form.Item
                name='url'
                labelCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: replaceI18nVariables(
                      getI18n('general.fieldisrequired'),
                      getI18n('storeCommunicationSetting.detail.uRL'),
                    ),
                  },
                  {
                    pattern:
                      /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?$/,
                    message: getI18n(
                      'storeCommunicationSetting.detail.pleaseenteravalidURL',
                    ),
                  },
                ]}
                label={
                  <Label
                    title={`${getI18n(
                      'storeCommunicationSetting.detail.uRL',
                    )}*`}
                  />
                }>
                <InputWithValue edit={editable}>
                  <Input size='large' disabled={disabled} />
                </InputWithValue>
              </Form.Item>
            ),
          },
          {
            child: null,
          },
        ]}
      />
    </Fragment>
  );
};

export default Zhima;
